import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { queryClient } from "./utils/query";
import { QueryClientProvider } from "react-query";

ReactDOM.render(
    <QueryClientProvider client={queryClient}>
        <App />
    </QueryClientProvider>,
    document.getElementById("root")
);
export { CourseWareTypeList } from "./utils/common";
